import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_2624770738 from "../../../../../packages/component/src/components/cascader/demo/demo1.js?loadDemo";
import legacyImportDemo_474856945 from "../../../../../packages/component/src/components/cascader/demo/demo2.js?loadDemo";
import legacyImportDemo_3235955504 from "../../../../../packages/component/src/components/cascader/demo/demo3.js?loadDemo";
import legacyImportDemo_1905479031 from "../../../../../packages/component/src/components/cascader/demo/demo4.js?loadDemo";
import legacyImportDemo_215824822 from "../../../../../packages/component/src/components/cascader/demo/demo5.js?loadDemo";
import legacyImportDemo_1319380213 from "../../../../../packages/component/src/components/cascader/demo/demo6.js?loadDemo";
import legacyImportDemo_3912761908 from "../../../../../packages/component/src/components/cascader/demo/demo7.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_2624770738,
  legacyImportDemo_474856945,
  legacyImportDemo_3235955504,
  legacyImportDemo_1905479031,
  legacyImportDemo_215824822,
  legacyImportDemo_1319380213,
  legacyImportDemo_3912761908,
  React
};